module.exports = __webpack_public_path__ + "static/img/modelDetails2.a6346fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/模型库/modelDetails2.png
// module id = vsKF
// module chunks = 1